var render, staticRenderFns
import script from "./doughnut-graph.vue?vue&type=script&lang=js"
export * from "./doughnut-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f080223')) {
      api.createRecord('3f080223', component.options)
    } else {
      api.reload('3f080223', component.options)
    }
    
  }
}
component.options.__file = "resources/js/views/graph/doughnut-graph.vue"
export default component.exports